import { defineMessages } from 'react-intl';
import type { MessageDescriptor } from 'react-intl';

type MessageKey =
  | 'descriptionPlaceholder'
  | 'labelPlaceholderAddTitle'
  | 'labelPlaceholderAddALabel'
  | 'metadataBadgeText';

const messages: Record<MessageKey, MessageDescriptor> = defineMessages({
  descriptionPlaceholder: {
    id: 'boxFileRequest.builder.descriptionPlaceholder',
    description: 'Placeholder text for help text and/or description input',
    defaultMessage: 'Add help text, or a description',
  },
  labelPlaceholderAddTitle: {
    id: 'boxForms.new.builder.label.add.title',
    description: 'Placeholder add a title for group',
    defaultMessage: 'Add a Title',
  },
  labelPlaceholderAddALabel: {
    id: 'boxForms.new.builder.label.add.label',
    description: 'Placeholder for adding a label to form',
    defaultMessage: 'Add a Label',
  },
  metadataBadgeText: {
    id: 'boxForms.new.builder.label.metadataBadgeText',
    description: 'Text for metadata badge in forms builder',
    defaultMessage: 'METADATA',
  },
});

export default messages;
